import type * as GraphQLTypes from '../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeletePackageExtraMutationVariables = GraphQLTypes.Exact<{
  packageId: GraphQLTypes.Scalars['String'];
  extraId: GraphQLTypes.Scalars['String'];
}>;


export type DeletePackageExtraMutationResult = (
  { __typename?: 'Mutation' }
  & Pick<GraphQLTypes.Mutation, 'deletePackageExtra'>
);


export const DeletePackageExtraDocument = /*#__PURE__*/ gql`
    mutation deletePackageExtra($packageId: String!, $extraId: String!) {
  deletePackageExtra(packageId: $packageId, extraId: $extraId)
}
    `;

/**
 * __useDeletePackageExtraMutation__
 *
 * To run a mutation, you first call `useDeletePackageExtraMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePackageExtraMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePackageExtraMutation, { data, loading, error }] = useDeletePackageExtraMutation({
 *   variables: {
 *      packageId: // value for 'packageId'
 *      extraId: // value for 'extraId'
 *   },
 * });
 */
export function useDeletePackageExtraMutation(baseOptions?: Apollo.MutationHookOptions<DeletePackageExtraMutationResult, DeletePackageExtraMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePackageExtraMutationResult, DeletePackageExtraMutationVariables>(DeletePackageExtraDocument, options);
      }
export type DeletePackageExtraMutationHookResult = ReturnType<typeof useDeletePackageExtraMutation>;